import { _ as _objectWithoutProperties } from '../unsorted/objectWithoutProperties.js';
import { a as _iterableToArray, _ as _toConsumableArray } from '../unsorted/toConsumableArray.js';
import { _ as _arrayWithHoles, a as _nonIterableRest } from '../unsorted/nonIterableRest.js';
import { _ as _unsupportedIterableToArray } from '../unsorted/unsupportedIterableToArray.js';
import { _ as _defineProperty } from '../unsorted/defineProperty.js';
import { _ as _typeof } from '../unsorted/typeof.js';
import { m as merge } from '../unsorted/index.js';
import { SHORTHAND_CSS_RULE_MAPPING } from '../constants.js';
import { s as smartPickTokenValue } from './processTokenUtils.js';

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

var _excluded = ["default"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function hasKey(key, object) {
  // @TODO: would be awesome to try and get this working
  // (because it actually narrows the type), but it's not a priority atm
  // ): object is { [_ in K]: {} } {
  return _typeof(object) === "object" && object !== null && key in object;
}

// @TODO: this is 99% the correct type, but still includes the shorthand rules.
// ideally, the type should only be longform rules.
function convertShorthandRule(rule) {
  var longHandRule = rule;
  if (hasKey(rule, SHORTHAND_CSS_RULE_MAPPING)) {
    longHandRule = SHORTHAND_CSS_RULE_MAPPING[rule];
  }
  return longHandRule;
}
function applyXandYStyleAmount(rule, value) {
  var _ref, _ref2;
  var rulePrefix = rule.substring(0, rule.length - 1);
  return rule.match(/[margin|padding]Y/) ? (_ref = {}, _defineProperty(_ref, "".concat(rulePrefix, "Top"), value), _defineProperty(_ref, "".concat(rulePrefix, "Bottom"), value), _ref) : (_ref2 = {}, _defineProperty(_ref2, "".concat(rulePrefix, "Left"), value), _defineProperty(_ref2, "".concat(rulePrefix, "Right"), value), _ref2);
}
function applyStyleAmount(rule, value, themeProps) {
  var _smartPickTokenValue;
  if (value === undefined || value === null) return {};
  var valueFromToken = (_smartPickTokenValue = smartPickTokenValue(themeProps, "".concat(value))) !== null && _smartPickTokenValue !== void 0 ? _smartPickTokenValue : value;
  var isGradient = _typeof(valueFromToken) === "object";
  if (isGradient && rule.match(/background$|backgroundImage$|^color/)) {
    var gradient = valueFromToken;
    var styleObject = {
      backgroundImage: gradient.spectrum,
      backgroundBlendMode: gradient.blendMode
    };
    return rule.match(/color/) ? _objectSpread(_objectSpread({}, styleObject), {}, {
      backgroundClip: "text",
      textFillColor: "transparent"
    }) : styleObject;
  }
  if (rule.match(/paddingX$|paddingY|marginY|marginX$/) && typeof valueFromToken === "string") {
    return applyXandYStyleAmount(rule, valueFromToken);
  }
  return _defineProperty({}, rule, valueFromToken);
}
function renderResponsiveStyles(rule, values, themeProps) {
  var _values = _toArray(values),
    defaultValue = _values[0],
    responsiveValues = _values.slice(1);
  var responsiveStyles = responsiveValues.map(function (responsiveValue, index) {
    var _themeProps$base$brea;
    var mediaStyleRule = "@media screen and (min-width: ".concat((_themeProps$base$brea = themeProps.base.breakpointAsArray) === null || _themeProps$base$brea === void 0 ? void 0 : _themeProps$base$brea[index], "px)");
    var cssValue = typeof responsiveValue === "function" ? responsiveValue(themeProps) : responsiveValue;
    return responsiveValue ? _defineProperty({}, mediaStyleRule, applyStyleAmount(rule, cssValue, themeProps)) : {};
  });
  var styles = _objectSpread(_objectSpread({}, defaultValue ? applyStyleAmount(rule, typeof defaultValue === "function" ? defaultValue(themeProps) : defaultValue, themeProps) : {}), Object.assign.apply(Object, [{}].concat(_toConsumableArray(responsiveStyles))));
  return styles;
}
function renderResponsiveStylesFromObject(rule, values, themeProps) {
  var defaultProp = values["default"],
    responsiveProps = _objectWithoutProperties(values, _excluded);
  var orderedArray = [defaultProp];
  var key;
  for (key in themeProps.base.breakpoint) {
    var responsiveStyle = responsiveProps[key];
    if (responsiveStyle) {
      orderedArray.push(responsiveStyle);
    } else {
      orderedArray.push(null);
    }
  }
  return renderResponsiveStyles(rule, orderedArray, themeProps);
}

// @TODO: the types here are not great. might need some work. :(
function renderDescendantStylesFromObject(descendantSelector, descendantValue, themeProps) {
  var descendantStyles = _defineProperty({}, descendantSelector, {});
  var key;
  for (key in descendantValue) {
    var rule = convertShorthandRule(key);
    var value = descendantValue[key];
    descendantStyles[descendantSelector] = merge(descendantStyles[descendantSelector], chooseWhichStylesToRender(rule, value, themeProps));
  }
  return descendantStyles;
}
function chooseWhichStylesToRender(rule, value, themeProps) {
  if (value === null) return {};

  // @NOTE: We must ignore any of the @emotion/react keyframe based
  // animation style objects, as these do NOT need to go through sx processing
  if (typeof value === "function" && typeof rule === "function") {
    return {};
  }
  var cssValue = typeof value === "function" ? value(themeProps) : value;

  // @TODO: find a way to not have to cast cssValue here (hint: its due to Array.isArray())
  return Array.isArray(cssValue) ? renderResponsiveStyles(rule, cssValue, themeProps) : _typeof(cssValue) === "object" && cssValue["default"] ? renderResponsiveStylesFromObject(rule, cssValue, themeProps) : _typeof(cssValue) === "object" ? renderDescendantStylesFromObject(rule, cssValue, themeProps) : applyStyleAmount(rule, cssValue, themeProps);
}
function sortStylesForMediaQueries(styles) {
  var keys = Object.keys(styles);
  var mediaKeys = keys.filter(function (key) {
    return key.startsWith("@media");
  });
  var nonMediaKeys = keys.filter(function (key) {
    return !key.startsWith("@media");
  });
  var sortedMediaKeys = mediaKeys.sort(function (a, b) {
    var _a$match$, _a$match, _b$match$, _b$match;
    var widthA = Number.parseInt((_a$match$ = (_a$match = a.match(/\d+/)) === null || _a$match === void 0 ? void 0 : _a$match[0]) !== null && _a$match$ !== void 0 ? _a$match$ : "", 10);
    var widthB = Number.parseInt((_b$match$ = (_b$match = b.match(/\d+/)) === null || _b$match === void 0 ? void 0 : _b$match[0]) !== null && _b$match$ !== void 0 ? _b$match$ : "", 10);
    return widthA - widthB;
  });
  var sortedObject = {};
  nonMediaKeys.forEach(function (key) {
    sortedObject[key] = styles[key];
  });
  sortedMediaKeys.forEach(function (key) {
    sortedObject[key] = styles[key];
  });
  return sortedObject;
}
function convertSxToEmotionStyles(sx, themeProps) {
  var stylesArray = [];

  // @NOTE: important that we use Object.getOwnPropertyNames instead of say,
  // Object.keys, as the latter will return keys which are ordered differently from
  // their insertion order (which is quite important given that rule order matters in CSS).
  // more about this here: https://stackoverflow.com/questions/5525795/does-javascript-guarantee-object-property-order/38218582#38218582
  Object.getOwnPropertyNames(sx).forEach(function (rule) {
    var typedRule = rule;
    var value = sx[typedRule];
    var longHandRule = convertShorthandRule(typedRule);
    if (value || typeof value === "number") {
      stylesArray.push(chooseWhichStylesToRender(longHandRule, value, themeProps));
    }
  });

  // @NOTE: we need to ensure that all @media rules are last, AND sorted
  // by their min-width values, as this is the only way to ensure that the
  // styles are applied in the correct order.
  return sortStylesForMediaQueries(merge.apply(void 0, [{}].concat(stylesArray)));
}

export { applyStyleAmount, applyXandYStyleAmount, chooseWhichStylesToRender, convertShorthandRule, convertSxToEmotionStyles, hasKey, renderDescendantStylesFromObject, renderResponsiveStyles, renderResponsiveStylesFromObject };
//# sourceMappingURL=sxToEmotionStyles.js.map
